import { render, staticRenderFns } from "./PipelineBoard.vue?vue&type=template&id=238949ea&scoped=true"
import script from "./PipelineBoard.vue?vue&type=script&lang=js"
export * from "./PipelineBoard.vue?vue&type=script&lang=js"
import style0 from "./PipelineBoard.vue?vue&type=style&index=0&id=238949ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238949ea",
  null
  
)

export default component.exports